import React from 'react';

import { InboxFilterContext, InboxFilterContextValue } from './InboxFilterContext';

export const InboxFilterProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [filterFormValues, setFilterFormValues] = React.useState<
    InboxFilterContextValue['filterFormValues']
  >({});

  const value: InboxFilterContextValue = React.useMemo(() => {
    return { filterFormValues, setFilterFormValues };
  }, [filterFormValues]);

  return <InboxFilterContext.Provider value={value}>{children}</InboxFilterContext.Provider>;
};
